import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const CreditsContentFallback = () => {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="h-9 w-24" />
      <Skeleton className="h-4 w-32" />
    </div>
  )
}

export const CreditsFallback = () => {
  return (
    <Card className="bg-secondary p-0 gap-0">
      <CardHeader className="px-5 pt-3 pb-1">
        <Skeleton className="h-4 w-24" />
      </CardHeader>
      <CardContent className="p-0 flex-1">
        <Card className="p-0 border-x-0 border-b-0 shadow-none h-full justify-center">
          <CardContent className="py-6">
            <CreditsContentFallback />
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  )
}
